import React from 'react';
import AEmail from '@material-ui/icons/AlternateEmail';

const AlternateEmail = (props) => <AEmail {...props} />;

export default AlternateEmail;
